import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import teamPhoto from '../../Assets/img/employer.webp';
import WithBackground from '../Common/WithBackground';

import './style.css';

const OurTeam = ({ bg, overlay = 'dark' }) => {
  const { t } = useTranslation();

  const teamContent = (
    <section className='our-team' id='team'>
      <div className='our-team__container'>
        <div className='our-team__header'>
          <h2
            className='our-team__title'
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {t('ourTeam.title')}
          </h2>
          <p
            className='our-team__intro'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            {t('workerKontakt.intro')}
          </p>
        </div>

        <div className='our-team__showcase'>
          <div className='team-showcase'>
            <div
              className='team-showcase__content'
              data-aos='fade-right'
              data-aos-delay='300'
            >
              <h3 className='team-showcase__title'>
                {t('ourTeam.showcase.title')}
              </h3>
              <p className='team-showcase__description'>
                {t('ourTeam.showcase.description')}
              </p>
              <div className='team-showcase__stats'>
                <div className='team-showcase__stat'>
                  <span className='team-showcase__stat-number'>100+</span>
                  <span className='team-showcase__stat-label'>
                    {t('ourTeam.showcase.stats.candidates')}
                  </span>
                </div>
                <div className='team-showcase__stat'>
                  <span className='team-showcase__stat-number'>10+</span>
                  <span className='team-showcase__stat-label'>
                    {t('ourTeam.showcase.stats.partners')}
                  </span>
                </div>
                <div className='team-showcase__stat'>
                  <span className='team-showcase__stat-number'>5+</span>
                  <span className='team-showcase__stat-label'>
                    {t('ourTeam.showcase.stats.experience')}
                  </span>
                </div>
              </div>
            </div>
            <div
              className='team-showcase__image'
              data-aos='fade-left'
              data-aos-delay='400'
            >
              <img
                src={teamPhoto}
                alt={t('ourTeam.showcase.imageAlt')}
                className='team-showcase__photo'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {teamContent}
    </WithBackground>
  ) : (
    teamContent
  );
};

OurTeam.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

OurTeam.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default OurTeam;
